import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams,useNavigate } from 'react-router-dom';
import { loadSCfilDate } from '../../utils/dateStorage';
import Conversation from '../../components/conversation/Conversation';
import { AGENTROLE, COACHING, MANAGERROLE, SUPERVISORROLE } from '../../constants';
import CoachingHistoryGrid from '../../features/coaching/coachingHistoryGrid/coachingHistoryGrid';
import { CoachingSummary } from '../../features/coaching/coachingSummary/CoachingSummary';
import { Revgen } from '../../features/coaching/revGen/Revgen';
import { ToDoView } from '../../features/coaching/toDoView/ToDoView';
import { TriadSummary } from '../../features/coaching/triad/TriadSummary';
import { CoachingTabs } from '../../utils/typeConstants';
import {
    selectCurrentIsAdmin,
    selectCurrentIsHC,
    selectCurrentRole,
    selectCurrentUser,
    selectCurrentUserParentClient,
    selectIsAllowCoachingActionModel,
    selectIsPseudoSupervisor,
    selectIsUseCoachingSkills,
} from '../login/authSlice';
import { ShoutOutView } from '../../features/coaching/shoutOutView/ShoutOutView';
import { CourseAssignment } from '../../features/coaching/courseAssignment/CourseAssignment';
import { RecordingHistory } from '../../features/coaching/recordingHistory/RecordingHistory';

export const Coaching = () => {
    const currentUserParentClient = useSelector(selectCurrentUserParentClient);
    const { TabId, teamOptionId, entityId, entityDate } = useParams();
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [date, setDate] = useState(new Date());
    const loggedUser = useSelector(selectCurrentUser);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const role = useSelector(selectCurrentRole);
    const isHC = useSelector(selectCurrentIsHC);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const isUseCoachingSkills = useSelector(selectIsUseCoachingSkills);
    const isAllowCoachingActionModel = useSelector(selectIsAllowCoachingActionModel);
    const isCoachingTabAllowed =
        (isAllowCoachingActionModel === false && (isAdmin || isHC || role === SUPERVISORROLE || isPseudoSupervisor === true || role === MANAGERROLE));
        
    const [activeTabIndex, setActiveTabIndex] = useState<number>(
        isCoachingTabAllowed
            ? CoachingTabs.Coaching
            : CoachingTabs.Conversation
    );
    const recordDetails = entityId ? entityId.split('-') : null;
    const recordYear = recordDetails && recordDetails.length === 3 ? Number(recordDetails[1]) : null;
    const recordMonth = recordDetails && recordDetails.length === 3 ? Number(recordDetails[2]) : null;
    const navigate = useNavigate();

    useEffect(() => {
        if (TabId) {
            setActiveTabIndex(Number(TabId));
        }
    }, [TabId]);
    useEffect(() => {
        return () => {
            localStorage.removeItem('selectedTeam');
        };
    }, []);

    useEffect(() => {
    if(recordDetails && recordYear && recordMonth){
        console.log('setting date from landing page');
    }
    else {
    const storedDate = loadSCfilDate();
    if (storedDate) {
        setDate(storedDate);
        setMonth(storedDate.getMonth() + 1);
            setYear(storedDate.getFullYear());
        }
    }
}, []);

    return (
        <div>
            <div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-4 text-start">
                            <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                {`Hello ${loggedUser}!`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {
                                <TabView
                                    activeIndex={activeTabIndex}
                                    onTabChange={(e) => {
                                        setActiveTabIndex(e.index);
                                        navigate(`${COACHING}`);
                                    }}
                                >
                                    {(isCoachingTabAllowed) && (
                                        <TabPanel header="CAPS">
                                            <CoachingSummary
                                                date={date}
                                                setDate={setDate}
                                                inputMonth={inputMonth}
                                                setMonth={setMonth}
                                                inputYear={inputYear}
                                                setYear={setYear}
                                                userParentClient={currentUserParentClient}
                                                teamOptionId={teamOptionId}
                                                entityId={entityId}
                                                entityDate={entityDate}
                                            />
                                        </TabPanel>
                                    )}
                                    <TabPanel header="Discussions">
                                        <Conversation
                                            date={date}
                                            setDate={setDate}
                                            setMonth={setMonth}
                                            setYear={setYear}
                                            teamOptionId={teamOptionId}
                                            entityId={entityId}
                                            entityDate={entityDate}
                                        />
                                    </TabPanel>
                                    <TabPanel header="To-Do List">
                                        <ToDoView teamOptionId={teamOptionId} entityId={entityId}/>
                                    </TabPanel>
                                    {role !== AGENTROLE && (
                                        <TabPanel header="Shout Outs">
                                            <ShoutOutView />
                                        </TabPanel>
                                    )}
                                    <TabPanel header="Activity">
                                        <CoachingHistoryGrid date={date} />
                                    </TabPanel>
                                    {(isAdmin ||
                                        isHC ||
                                        role === SUPERVISORROLE ||
                                        isPseudoSupervisor === true ||
                                        role === MANAGERROLE) && (
                                        <TabPanel header="Coaching Observations">
                                            <TriadSummary
                                                date={(TabId === '6' && recordMonth && recordYear) ? new Date(recordYear, recordMonth) : date}
                                                setDate={setDate}
                                                inputMonth={(TabId === '6' && recordMonth) ? recordMonth : inputMonth}
                                                setMonth={setMonth}
                                                inputYear={ (TabId === '6' && recordYear) ? recordYear : inputYear}
                                                setYear={setYear}
                                                userParentClient={currentUserParentClient}
                                                entityId={entityId}
                                                entityDate={entityDate}
                                                teamOptionId={teamOptionId}
                                            />
                                        </TabPanel>
                                    )}
                                    <TabPanel header="RevGen">
                                        <Revgen
                                            date={date}
                                            setDate={setDate}
                                            inputMonth={inputMonth}
                                            setMonth={setMonth}
                                            inputYear={inputYear}
                                            setYear={setYear}
                                            entityId={entityId}
                                            entityDate={entityDate}
                                            teamOptionId={teamOptionId}
                                        />
                                    </TabPanel>
                                    {isUseCoachingSkills && (
                                        <TabPanel header="On-Demand Learning">
                                            <CourseAssignment />
                                        </TabPanel>
                                    )}
                                    {(role === SUPERVISORROLE || isPseudoSupervisor) && (
                                        <TabPanel header="Recordings">
                                            <RecordingHistory />
                                        </TabPanel>
                                    )}
                                </TabView>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
